const STORAGE_KEY = 'sensai.referralCode';

// Reads ?ref= off the current URL and stashes it in localStorage, so it survives the onboarding
// funnel's redirects/steps (which don't preserve query strings) until account creation actually
// happens. Never overwrites an already-stored code — first link a visitor lands on wins.
export function captureReferralCodeFromUrl() {
  const code = new URLSearchParams(window.location.search).get('ref');
  if (code && !localStorage.getItem(STORAGE_KEY)) {
    localStorage.setItem(STORAGE_KEY, code);
  }
}

export function consumeStoredReferralCode() {
  return localStorage.getItem(STORAGE_KEY);
}

export function clearStoredReferralCode() {
  localStorage.removeItem(STORAGE_KEY);
}
